import Base from 'app/views/base';
import { showResponseError } from 'utils/messages';

import Shipment from 'app/models/shipment';
import ShipmentCreateModal from './modal';

import tmpl from './template';


export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .showModal': 'showNewModal',
    'click .close': 'hideModal',
  },

  initialize({ apiModeSelection }) {
    this.initializeModal = this.initializeModal.bind(this);
    this.apiModeSelection = apiModeSelection;
    this.initializeModal();
  },

  onBuySuccess(shipment) {
    this.trigger('buy:success', shipment);
  },

  onBuyError(response, shipment) {
    this.trigger('buy:error', response, shipment);
    showResponseError(response);
  },

  showModal() {
    this.modal.show();
  },

  showNewModal() {
    this.resetModal();
    this.showModal();
  },

  closeModal() {
    this.modal.close();
  },

  resetModal(shipment) {
    this.modal.remove();
    this.model = shipment;
    this.initializeModal();
  },

  initializeModal() {
    this.model = this.model || new Shipment({
      ...this.apiModeSelection.getParams(),
    }, {
      initializeNestedModels: true,
    });

    this.modal = new ShipmentCreateModal({
      apiModeSelection: this.apiModeSelection,
      shipment: this.model,
    });

    this.modal.on('buy:success', shipment => this.onBuySuccess(shipment));
    this.modal.on('buy:error', (response, shipment) => this.onBuyError(response, shipment));
    this.modal.on('closed', () => this.resetModal);
    this.modal.on('closed', () => this.trigger('closed'));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/shipments/create/index.js